const BrandIcon = Object.freeze({
  1: '//cdn.myfunnow.com/admin/favicon/favicon.png',
  2: '//cdn.myfunnow.com/admin/favicon/nd-favicon.png',
  3: '//cdn.myfunnow.com/admin/favicon/etg-favicon.png'
})

const BrandFieldSalesMode = Object.freeze({
  1: 'Play',
  2: 'Pro'
})

const BrandID = Object.freeze({
  FunNow: 1,
  Niceday: 2,
  Eatigo: 3,
  SaaS: 4
})

export {
  BrandIcon,
  BrandFieldSalesMode,
  BrandID
}
